<template>
  <div class="interstitial-section">
    <span class="accordion-title">
      {{ $t("accordion_interstitial_title") }}
    </span>
    <AccordionVideoContainer
      :videoIds="[
        '352898182',
        '605506909',
        '605506802',
        '440251946',
        '440014204',
      ]"
    />
    <ListWithArrows
      :entriesLeft="[
        'accordion_interstitial_arrow_list_1',
        'accordion_interstitial_arrow_list_2',
      ]"
      :entriesRight="[
        'accordion_interstitial_arrow_list_3',
        'accordion_interstitial_arrow_list_4',
      ]"
    />
    <ScientificInformationCardRow :count="4" prefix="accordion_interstitial" />
    <ProductsForIntervention
      :leftItems="['20402-410', '20402-401', '20402-402']"
      :leftInformation="[
        'accordion_interstitial_products_information_1',
        'accordion_interstitial_products_information_2',
        'accordion_interstitial_products_information_3',
      ]"
      :leftButtonLink="
        'https://de.erbe-med.com/productfinder/index.php?openurl=PLM_PRODUKTKATEGORIE%3DInstrument%7CPLM_PRODUKTGRUPPE%3DFlexible%20Sonden%7CPLM_PRODUKTUNTERGRUPPE%3DERBECRYO%202&language=en'
      "
    />
  </div>
</template>

<script>
import ScientificInformationCardRow from "@/components/ScientificInformationCardRow";
import ListWithArrows from "../../components/ListWithArrows.vue";
import AccordionVideoContainer from "../../components/AccordionVideoContainer.vue";
import ProductsForIntervention from "../../components/ProductsForIntervention.vue";

export default {
  name: "InterstitialSection",
  components: {
    ScientificInformationCardRow,
    ListWithArrows,
    AccordionVideoContainer,
    ProductsForIntervention,
  },
};
</script>

<style lang="scss">
@import "@/assets/scss";
.interstitial-section {
  display: flex;
  flex-direction: column;
  font-family: $font_nettoRegular;
  background-color: lightgray;
  background: -webkit-radial-gradient(circle center 50%, lightgray, gray);
  background: radial-gradient(circle at center 50%, lightgray, gray);
  align-items: center;
  cursor: default;
  padding-top: 1rem;
}
</style>
